export const hasVendorChatDom = () =>
  !!document.getElementById("ChatWindow") ||
  !!document.getElementById("Chat") ||
  !!document.getElementById("ChatParent");

export const cleanupVendorChatDom = () => {
  document.getElementById("ChatParent")?.remove();
  document.getElementById("Chat")?.remove();
};

const showVendorChatUi = () => {
  const chatWindow = document.getElementById("ChatWindow");
  if (chatWindow) chatWindow.classList.remove("chat-hidden");

  const chatParent = document.getElementById("ChatParent");
  if (chatParent) {
    (chatParent as HTMLElement).style.display = "";
    (chatParent as HTMLElement).style.visibility = "visible";
  }

  const chatRoot = document.getElementById("Chat");
  if (chatRoot) {
    (chatRoot as HTMLElement).style.display = "";
    (chatRoot as HTMLElement).style.visibility = "visible";
  }
};

const clickReconnectIfPresent = () => {
  const reconnect = document.getElementById("reconnect") as HTMLElement | null;
  if (!reconnect) return;

  queueMicrotask(() => reconnect.click());
};

export const openChatAndReconnectIfNeeded = () => {
  showVendorChatUi();
  clickReconnectIfPresent();
};
